import { apiGet, apiPost } from "./apiUtils";
import {  getLoggedInUserTenantID } from "./sessionUtil";

 var agents = 
 [
     {
         "id": 1,
         "category": "America",
         "name": "dev1",
         "version": "v1.0",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot1","bot2"],
         "tags": ["PROJ1", "DEV"]
     },
     {
         "id": 2,
         "category": "America",
         "name": "dev2",
         "version": "v1.0",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot1","bot2"],
         "tags": ["PROJ1", "QA"]
     },
     {
         "id": 3,
         "version": "v1.0",
         "category": "Europe",
         "name": "eur1",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot1","bot2"],
         "tags": ["PROJ1", "PROD"]
     },
     {
         "id": 4,
         "version": "v1.1",
         "category": "Europe",
         "name": "eur2",
         "status": "INACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot3","bot4"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 5,
         "version": "v1.1",
         "category": "Asia",
         "name": "asiadev1",
         "status": "INACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 6,
         "version": "v1.1",
         "category": "Asia",
         "name": "asiaqa1",
         "status": "ACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 7,
         "version": "v1.1",
         "category": "Asia",
         "name": "asiaprod1",
         "status": "ACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 8,
         "version": "v1.1",
         "category": "Asia",
         "name": "asiaprod1",
         "status": "ACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 9,
         "version": "v1.1",
         "category": "Asia",
         "name": "asiaprod1",
         "status": "ACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 10,
         "version": "v1.1",
         "category": "Australia",
         "name": "ausdev1",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 11,
         "version": "v1.1",
         "category": "Australia",
         "name": "ausdev2",
         "status": "ACTIVE",
         "trigger": "TIMER",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 12,
         "version": "v1.1",
         "category": "Africa",
         "name": "afrdev1",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },
     {
         "id": 13,
         "version": "v1.1",
         "category": "Africa",
         "name": "afrqa1",
         "status": "ACTIVE",
         "trigger": "API",
         "botsinstalled": ["bot6"],
         "tags": ["PROJ2", "DEV"]
     },

 ]
;
export function getAgents() {
 
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/agent/getAgentsByTenantId/${tenantId}`
    return apiGet(url).then(json => {
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    
}

export function createAgent(agent,setAgentsChangedTrigger){

    agent.tenantId = getLoggedInUserTenantID();
    console.log(agent)
    let url = `${process.env.REACT_APP_API_PREFIX}/agent/createAgent`
    return apiPost(url,agent).then(res => {
        if(res.ok){
            setAgentsChangedTrigger(true);
            return res.json()

        }else{
            console.log("Response is not ok during apiPost CreateAgent. thowing exception")
            throw new Error("Response is not ok during apiPost CreateAgent.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during createAgent ${err.message}`)
        throw new Error("Server error during creating Agent");
    })


}

export function getAgentsByEnvironment(env){

    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/agent/getAgentsByTenantIdAndEnvironment/tenant/${tenantId}/envrionment/${env}`
    return apiGet(url)
    .then(json=>{
        // console.log(`json result ${json.result}`);
        // console.log(`json message ${json.message}`);
        console.log(`json data ${url} ${JSON.stringify(json.data)}`);
        return json.data;
    })

}




export function updateAgent(agent,setAgentsChangedTrigger){
    // var index = agents.findIndex((a) => a.id === agent.id);
    // agents[index] = {...agent};
    // agents[index].botsinstalled = [...agent.botsinstalled];
    let url = `${process.env.REACT_APP_API_PREFIX}/agent/updateAgent`
    let tenantId = getLoggedInUserTenantID();
    return apiPost(url,agent).then(res => {
        if(res.ok){
            setAgentsChangedTrigger(true);
            return res.json()

        }else{
            console.log("Response is not ok during apiPost CreateAgent. thowing exception")
            throw new Error("Response is not ok during apiPost CreateAgent.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during Updating ${err.message}`)
        throw new Error("Server error during creating Agent");
    })

}

export function deleteAgent(agent,setAgentsChangedTrigger){
  

    let url = `${process.env.REACT_APP_API_PREFIX}/agent/deleteAgent`;
    let tenantId = getLoggedInUserTenantID();
    return apiPost(url,agent).then(res => {
        if(res.ok){
            setAgentsChangedTrigger(true);
            return res.json()

        }else{
            console.log("Response is not ok during apiPost CreateAgent. thowing exception")
            throw new Error("Response is not ok during apiPost CreateAgent.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during createAgent ${err.message}`)
        throw new Error("Server error during Deleting Agent");
    })


}

export function getAgentStatuses(){
    const statuses = ["ACTIVE","DISABLED","INACTIVE"];
    return statuses;
}

export function getCertifiedBots(){
    const certifiedBots = ["bot1","bot2","bot3","bot4","bot5","bot6","bot7"];
    return certifiedBots;
}

export function getTriggers(){
    const triggers = ["TIMER","API"];
    return triggers;
}

export function cloneAgentsFromEnv(sourceEnv,targetEnv,onCloneComplete){
    let url = `${process.env.REACT_APP_API_PREFIX}/agent/cloneAgentsByTenantIdAndEnvironment`;
    let tenantId = getLoggedInUserTenantID();

    let data ={
        tenantId:getLoggedInUserTenantID(),
        sourceEnvironment:sourceEnv,
        targetEnvironment:targetEnv
    }
    return apiPost(url,data).then(res => {
        if(res.ok){
            onCloneComplete();
            return res.json()

        }else{
            console.log("Response is not ok during apiPost cloneAgentsFromEnv. thowing exception")
            throw new Error("Response is not ok during apiPost cloneAgentsFromEnv.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during cloneAgentsFromEnv ${err.message}`)
        throw new Error("Server error during cloneAgentsFromEnv ");
    })

}


export function promoteBotsToEnv(env){
    
}